import modal from './modal.vue';

export default {
    install(Vue) {
        // 生成一个Vue的子类
        // 同时这个子类也就是组件
        const Constructor = Vue.extend(modal);
        // 生成一个该子类的实例
        const instance = new Constructor();
        // 将这个实例挂载在我创建的div上
        // 并将此div加入全局挂载点内部
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);

        // 通过Vue的原型注册一个方法
        // 让所有实例共享这个方法
        Vue.prototype.$modal = ({
            title,
            content,
            showCancel,
            cancelText,
            confirmText,
        }) => {
            instance.show = false;
            instance.show2 = false;

            instance.title = title;
            instance.content = content;
            instance.showCancel = showCancel;
            instance.cancelText = cancelText;
            instance.confirmText = confirmText;

            instance.show = true;
            setTimeout(() => {
                instance.show2 = true;
            }, 50);

            return new Promise((resolve, reject) => {
                instance.promiseStatus = { resolve, reject };
            });
        };
    },
};
